import React from 'react'
import { Box, ListItemButton } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'

import { List, ListItem, ListItemText, ListItemIcon } from '@mui/material'
import UserProfileCard from '../UserProfileCard/UserProfileCard'
import UsageReportCard from '../UsageReportCard/UsageReportCard'
import useUsageReport from '../../api/quota/useUsageReport'
import { t } from 'i18next'
import { iconStyle, listItemTextStyle, logoTextStyle, menuButtonStyle } from './SideBarMenu.styles'
import { MenuOption } from './types'

type SidebarMenuProps = {
	sidebarOpen: boolean
	menuOptions: MenuOption[]
}

export default function SidebarMenu({ sidebarOpen, menuOptions = [] }: SidebarMenuProps) {
	const { refetch } = useUsageReport()
	const location = useLocation()
	const isActive = (paths: string[]) => paths.some((path) => location.pathname.includes(path))

	return (
		<Box display="flex" flexDirection="column" height="100vh" justifyContent="space-between">
			<List component="nav">
				<ListItem>
					<ListItemIcon>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/new_prop_p.svg`}
							alt="Logo"
							style={{ maxWidth: '100%', height: '25px' }}
						/>
					</ListItemIcon>
					<ListItemText primary={t('prop_ai')} sx={logoTextStyle({ sidebarOpen })} />
				</ListItem>

				<ListItem>
					<Box height="24px" />
				</ListItem>

				{menuOptions.map(({ path, MenuIcon, label, location }) => {
					return (
						<ListItemButton
							key={path}
							component={Link}
							to={path}
							onClick={() => refetch()}
							sx={menuButtonStyle({ isActive: isActive(location), sidebarOpen })}
						>
							<ListItemIcon sx={iconStyle(isActive(location))}>
								<MenuIcon />
							</ListItemIcon>
							<ListItemText primary={label} sx={listItemTextStyle(isActive(location), sidebarOpen)} />
						</ListItemButton>
					)
				})}
			</List>
			<Box>
				<UsageReportCard sidebarOpen={sidebarOpen} />
				<UserProfileCard sidebarOpen={sidebarOpen} />
			</Box>
		</Box>
	)
}
